<div class="wrapper">
  @if (context !== undefined) {
    <div class="content" [class.disabled]="isShowSpinner">
      <ng-container *ngTemplateOutlet="templateRef; context: context">
      </ng-container>
    </div>
  }

  @if (isShowSpinner) {
    @if (context !== undefined) {
      <div class="spinner-overlay">
        <ts-spinner-ui></ts-spinner-ui>
      </div>
    } @else {
      <ts-spinner-ui></ts-spinner-ui>
    }
  }
</div>
